import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import LogActivityContent from "modules/LogActivity";

import React from "react";

import { setTitle } from "utilities/helper/setTitle";

const LogActivityPage: React.FC = () => {
  setTitle("Log Activity");
  return (
    <Auth>
      <Layout>
        <LogActivityContent />
      </Layout>
    </Auth>
  );
};

export default LogActivityPage;
